<app-label-inflator
  #labelCalculator
  hidden
  class="label-calculator"
  [calculateVirtualLabel]="true"
  [columnLabel]="false"
  [labelComponentInterface]="data"
  [reset]="false">
</app-label-inflator>
<div class="main-content">
  <div class="top-container">
    <div class="product-cannabinoids-container" [style.color]="viewModel.bodyTextColor$ | async">
      @for (data of viewModel.propertiesBasedOnPools$ | async; track data?.title; let last = $last) {
        <div class="cannabinoid">
          <div class="cannabinoid-title">{{ data?.title }}</div>
          <div class="cannabinoid-value">{{ data?.value | trimSafely }}</div>
        </div>
        <div *ngIf="!last" class="cannabinoid-separator">|</div>
      }
    </div>
  </div>

  <div class="bottom-container">
    <div class="product-brand-and-product">
      <div
        *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
        class="product-card-brand"
        [style.color]="viewModel.headerTextColor$ | async">
        {{ brand }}
      </div>
      <div #productCardName class="product-card-name" [style.color]="viewModel.headerTextColor$ | async">
        {{ data | sectionRowViewModelBasicMethod: 'getRowTitle' | trimSafely }}
      </div>
    </div>

    <hr
      class="card-separator"
      [style.background-color]="(viewModel.cardAccentColor$ | async) || (viewModel.bodyTextColor$ | async)" />

    <div class="product-card-info">
      <div class="left-side">
        <div class="product-card-badge-and-label-container">
          <img
            *ngFor="let variantBadge of data | printCardBadges"
            appImage
            class="product-card-badge"
            [asset]="variantBadge?.image"
            alt="badge"
            src="" />
          <app-label-inflator
            class="print-card-label"
            [columnLabel]="false"
            [labelComponentInterface]="data"
            [reset]="false">
          </app-label-inflator>
        </div>

        <div class="strain-and-quantity-container" [style.color]="viewModel.bodyTextColor$ | async">
          <div *ngIf="viewModel.strainText$ | async as strainType" class="product-card-strain-type">
            {{ strainType }}
          </div>
          <div
            *ngIf="(viewModel.strainText$ | async) && (viewModel.productSizeExists$ | async)"
            class="product-card-strain-quantity-separator">
            |
          </div>
          <div *ngIf="viewModel.productSize$ | async as size" class="product-card-quantity">
            {{ size }}
          </div>
        </div>
      </div>

      <div class="product-card-price-container" [style.color]="viewModel.bodyTextColor$ | async">
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [productStylingVm]="viewModel"
          [leadingTextOriginalPriceWithSale]="'WAS '"
          [leadingTextSalePrice]="viewModel.virtualLabelText$ | async"
          [includeLineThroughOnLeadingTextOriginalPriceWithSale]="false"
          [ignoreStylingForSaleText]="false">
        </app-column-primary-price>
      </div>
    </div>
  </div>
</div>
